module.exports = __webpack_public_path__ + "img/salvar-personalizacoes.2fa2390a.svg";